<!--
 * @Author:
 * @Description:二维码支付，公共页面
 * @Date: 2024-10-22 09:50:48
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-checkout-web/src/views/payment/local-qris.vue
-->
<template>
  <div ref="local" id="local" class="local-wrapper">
    <!-- 全屏加载遮罩 -->
    <div v-loading.fullscreen="fullscreenLoading" style="height: 100%;">
    <!-- 主要内容区域 -->
    <div class="payment-container" v-if="paymentInfo">
      <!-- 暂时去掉倒计时 -->
      <!-- <div class="OnCountdownTimer" v-if="isMobile">
          <OnCountdownTimer style="margin-bottom: 24px;" :merchantTxnTime="paymentInfo.presentContext.expirationDate"
           :effectiveMinutes="720" />
        </div> -->
      <!-- 左侧订单信息区域 -->
      <div class="left-section">
        <OrderInfoVue :order="paymentInfo" :showCopyBtn="false" :isFormatAmount="paymentInfo?.paymentMethod === 'QRIS'"  :isMobile="isMobile" v-if="!isMobile"/>
        <orderSummary v-else :orderGetter="paymentInfo" :viewTxnId="paymentInfo.merchantTxnId" class="order-summary" ref="orderSummaryRef"  :isFormatAmount="true"/>
      </div>
      <!-- 右侧支付信息区域 -->
      <div class="right-section">
        <!-- 倒计时--暂时去掉 -->
        <!-- <div class="OnCountdownTimer" v-if="!isMobile">
          <OnCountdownTimer style="margin-bottom: 24px;" :merchantTxnTime="paymentInfo.presentContext.expirationDate"
           :effectiveMinutes="720" />
        </div> -->
      <div class="content">
          <!-- 支付方式标识 -->
          <div class="payment-method">
            <div class="payment-method-label">{{ $t('message.checkout.paymentMethod') }}</div>
            <img
              v-if="paymentInfo.checkoutModelResp && paymentInfo.checkoutModelResp.base64Logo"
              :src="`data:image/png;base64,${paymentInfo.checkoutModelResp.base64Logo}`"
              alt="Payment Method"
              class="payment-logo"
            />
        </div>
        <div class="validity-section">
          <!-- scanQrCode -->
          <div class="scan-title"> {{ $t('message.QR.scanQrCode') }}</div>
          <div class="validity-badge">
            <i class="el-icon-warning-outline"></i>
            {{ $t('message.QR.validFor24h') }}
          </div>
        </div>
        <!-- 二维码扫描区域 -->
        <div class="qr-section">
          <div class='warning-info'>{{ $t('message.QR.scanQrCodeOrDownload') }}</div>
          <div class="ticket-item"  v-if="paymentInfo.presentContext.pixCopyAndPaste">
            <div class="ticket">{{ paymentInfo.presentContext.pixCopyAndPaste }}</div>
            <el-button class="button" type="text" @click="copyTicket">
              <span class="iconfont icon-rongqi"></span>
            </el-button>
          </div>
          <!-- 二维码图片 -->
          <div class="qr-code-container" v-if="paymentInfo.presentContext && paymentInfo.presentContext.base64Image">
            <img
              :src="`data:image/png;base64,${paymentInfo.presentContext.base64Image}`"
              alt="QR Code"
              class="qr-code-image"
            />
          </div>
                    <!-- 下载按钮 -->
          <on-button class="download-btn" @click="downloadQrCode">
            {{ $t('message.QR.downloadQr') }}
            <img class="icon-down" src="@/assets/images/icon-down.png" alt="Download QR" >
          </on-button>
        </div>
      </div>

      <!-- 支付状态检查文案 -->
      <div class="payment-status-check">
        <div class="status-text-1">{{ $t('message.result.paymentStatusCheckText1') }}</div>
        <div class="status-text-2" @click="checkTransactionStatus">{{ $t('message.result.paymentStatusCheckText2') }}</div>
      </div>
      </div>
    </div>
  </div>
  <!-- 错误----pc -->
  <Modal v-if="!isMobile" :modelValue="errorModalInfo.modelValue"
      :title="errorModalInfo.title"
      :description="errorModalInfo.description"
      :status="errorModalInfo.status"
      :buttonText="errorModalInfo.buttonText"
      :redirectUrl="errorModalInfo.redirectUrl"
    />
    <Modal v-if="!isMobile"  :modelValue="successModalInfo.modelValue"
      :title="successModalInfo.title"
      :description="successModalInfo.description"
      :status="successModalInfo.status"
      :buttonText="successModalInfo.buttonText"
      :redirectUrl="successModalInfo.redirectUrl"
      :billingAddress="successModalInfo.billingAddress"
    />
    <Modal v-if="!isMobile" :modelValue="warnModalInfo.modelValue"
      :customButtonClick="true"
      :title="warnModalInfo.title"
      :description="warnModalInfo.description"
      :status="warnModalInfo.status"
      :buttonText="warnModalInfo.buttonText"
      @click="warnModalInfo.modelValue = false"
    />

    <!-- popupBottom--移动端支付成功失败的结果 -->
    <popupBottom v-if="isMobile" :open="resultPopup.visible" :redirectUrl="resultPopup.redirectUrl"
      :popupStatus="resultPopup.popupStatus" :popupTitle="resultPopup.popupTitle" :popupText="resultPopup.popupText"
      :billingAddress="resultPopup.billingAddress"
      :showReturnBtn="!resultPopup.showCustomBtn"
      :showCustomBtn="resultPopup.showCustomBtn" :customButtonText="resultPopup.customButtonText"
      @custom-button-click="handleCustomButtonClick">
    </popupBottom>
 </div>
</template>
<script>
import FileSaver from 'file-saver';
import { toBlob } from 'html-to-image';

import { getStatus, getLocalPaymentInfo } from '@/api/checkout';
import orderSummary from '@/components/orderSummary/index.vue';
import popupBottom from '@/components/popupBottom/index.vue';
// import OnCountdownTimer from '@/componentsV2/busi/countdown-timer/index.vue';
import Modal from '@/componentsV2/busi/Modal/Modal.vue';
import { formatAmountWithDotsCommas, convertBeijingTimeToLocal } from '@/utils/tools/format';
import { copyString } from '@/utils/tools/utils';

import OrderInfoVue from '../../componentsV2/busi/OrderInfo/OrderInfo.vue';

export default {
  components: {
    OrderInfoVue,
    // OnCountdownTimer,
    orderSummary,
    Modal,
    popupBottom,
  },
  data() {
    return {
      fullscreenLoading: true,
      txnId: '',
      paymentInfo: null,
      showErrorMsg: false,
      showCardName: false,
      pollingTimer: null,
      pollingCount: 0,
      // maxPollingTime: 15 * 60 * 1000, // 移除固定轮询时间，改用基于交易时间的检查
      // pollingStartTime: null, // 移除轮询开始时间记录
      isPollingActive: false,
      errorModalInfo: {
        modelValue: false,
        title: this.$t('message.result.failed'),
        description: this.$t('message.result.failedPop'),
        status: 'error',
        buttonText: this.$t('message.checkout.returnMerchant'),
        redirectUrl: '',
      },
      successModalInfo: {
        modelValue: false,
        title: this.$t('message.result.success'),
        description: this.$t('message.result.successPop'),
        status: 'success',
        buttonText: this.$t('message.checkout.returnMerchant'),
        redirectUrl: '',
        billingAddress: '',
      },
      warnModalInfo: {
        modelValue: false,
        title: this.$t('message.result.processingTitle') + '...',
        description: this.$t('message.result.processingDescription'),
        status: 'warn',
        buttonText: this.$t('message.result.processingButtonText'),
      },
      resultPopup: {
        visible: false,
        popupStatus: '',
        popupTitle: '',
        popupText: '',
        redirectUrl: '',
        billingAddress: '',
        showCustomBtn: false,
        customButtonText: '',
      },
    };
  },
  created() {
    this.txnId = this.$route.query.txnId;
    getLocalPaymentInfo(this.txnId).then((res) => {
      this.fullscreenLoading = false;
      if (res.respCode === '20000') {
        this.paymentInfo = res.data;
        if (res.data.brandConfig) {
          this.$store.dispatch('app/setBrandInfo', res.data.brandConfig);
        }
        if (!res.data) {
          this.showErrorMsg = true;
        } else {
          this.startPolling();
        }
      } else {
        this.showErrorMsg = true;
      }
    }).catch(() => {
      this.showErrorMsg = true;
      this.fullscreenLoading = false;
    });
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    formatAmountWithDotsCommas,
    copyTicket() {
      copyString(this.paymentInfo.presentContext.pixCopyAndPaste);
    },
    download() {
      toBlob(this.$refs.local)
        .then(() => {
          // Fix Safari 会显示图片失败，使用再次绘制处理
          toBlob(this.$refs.local)
            .then((blob) => {
              console.log(blob, 'blob');

              if (window.saveAs) {
                window.saveAs(blob, 'payment_code.jpg');
              } else {
                FileSaver.saveAs(blob, 'payment_code.jpg');
              }
            }).catch((error) => {
              console.log('download page error', error);
            });
        }).catch((error) => {
          console.log('download page error', error);
        });
    },
    // 直接下载二维码图片
    downloadQrCode() {
      if (this.paymentInfo && this.paymentInfo.presentContext && this.paymentInfo.presentContext.base64Image) {
        // 将base64转换为Blob对象
        const byteString = atob(this.paymentInfo.presentContext.base64Image);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: 'image/png' });

        // 使用FileSaver保存图片
        if (window.saveAs) {
          window.saveAs(blob, 'payment_code.png');
        } else {
          FileSaver.saveAs(blob, 'payment_code.png');
        }
      }
    },
    startPolling() {
      if (this.isPollingActive) return;
      this.isPollingActive = true;
      // 移除 pollingStartTime 设置，改用基于交易时间的检查
      this.pollingCount = 0;
      this.queryPaymentStatus();
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer);
        this.pollingTimer = null;
      }
      this.isPollingActive = false;
    },
    getPollingInterval() {
      if (this.pollingCount <= 5) {
        return 2000; // 2秒
      } else if (this.pollingCount <= 15) {
        return 5000; // 5秒
      } else if (this.pollingCount <= 30) {
        return 10000; // 10秒
      } else {
        return 15000; // 15秒
      }
    },
    /**
     * 检查一次支付状态（不启动轮询）
     * @author Nemo
     * @date 2025-07-11
     */
    checkPaymentStatusOnce() {
      const key = this.$route.query.key;
      return getStatus(key).then((res) => {
        this.handlePaymentStatusResponse(res, false);
        return res;
      }).catch((error) => {
        console.error('查询支付状态失败:', error);
        throw error;
      });
    },

    /**
     * 处理支付状态响应
     * @param {Object} res - 响应数据
     * @param {Boolean} isPolling - 是否为轮询调用
     * @author Nemo
     * @date 2025-07-11
     */
    handlePaymentStatusResponse(res, isPolling = true) {
      if (res.respCode === '20000' && res.data) {
        const { status, txnDate } = res.data;

        // 检查时间间隔，决定是否继续轮询
        if (isPolling && txnDate && !this.shouldContinuePolling(txnDate)) {
          this.stopPolling();
          console.log('交易时间超过15分钟或时间异常，停止轮询');
          return;
        }

        if (status === 'S') {
          if (isPolling) this.stopPolling();
          this.handlePaymentSuccess(res.data);
        } else if (status === 'F') {
          if (isPolling) this.stopPolling();
          this.handlePaymentFailed(res.data?.reason || res.respMsg || '', res.data);
        } else if (status === 'P' || status === 'R') {
          if (isPolling) {
            this.scheduleNextPolling();
          } else {
            // 手动查询时，如果是处理中状态，显示警告弹窗
            if (status === 'P') {
              this.showWarnModal();
            }
          }
        }
      } else {
        this.handlePaymentFailed(res.respMsg);
        if (isPolling) this.stopPolling();
      }
    },

    queryPaymentStatus() {
      // 移除原有的基于轮询开始时间的超时检查，改用基于交易时间的检查
      this.pollingCount += 1;
      const key = this.$route.query.key;
      getStatus(key).then((res) => {
        this.handlePaymentStatusResponse(res, true);
      }).catch((error) => {
        console.error('查询支付状态失败:', error);
        this.scheduleNextPolling();
      });
    },
    scheduleNextPolling() {
      if (!this.isPollingActive) return;
      const interval = this.getPollingInterval();
      this.pollingTimer = setTimeout(() => {
        this.queryPaymentStatus();
      }, interval);
    },
    handlePaymentSuccess(data) {
      if (this.isMobile) {
        this.resultPopup = {
          visible: true,
          popupStatus: 'success', // success
          popupTitle: this.$t('message.result.success'),
          popupText: `${this.$t('message.result.successPop')}`,
          redirectUrl: data.returnUrl,
          billingAddress: data.billingAddress,
        };
      } else {
        this.successModalInfo.modelValue = true;
        this.successModalInfo.redirectUrl = data.returnUrl;
        this.successModalInfo.billingAddress = data.billingAddress;
      }
    },
    handlePaymentFailed(errorMsg, data) {
      if (this.isMobile) {
        this.resultPopup = {
          visible: true,
          popupStatus: 'failed', // success
          popupTitle: this.$t('message.result.failed'),
          popupText: `${this.$t('message.result.reason')}: ${errorMsg || ''}`,
          redirectUrl: data?.returnUrl,
          billingAddress: data?.billingAddress,
        };
      } else {
        this.errorModalInfo.modelValue = true;
        this.errorModalInfo.description = errorMsg;
        this.errorModalInfo.redirectUrl = data?.returnUrl;
      }
    },
    /**
     * 检查交易状态（手动触发一次）
     * @author Nemo
     * @date 2025-07-11
     */
    checkTransactionStatus() {
      // 手动触发一次状态查询，不启动轮询
      this.checkPaymentStatusOnce().catch((error) => {
        console.error('手动检查支付状态失败:', error);
      });
    },

    /**
     * 显示警告弹窗
     * @author Nemo
     * @date 2025-07-11
     */
    showWarnModal() {
      if (this.isMobile) {
        this.resultPopup = {
          visible: true,
          popupStatus: 'warn',
          popupTitle: this.$t('message.result.processingTitle') + '...',
          popupText: this.$t('message.result.processingDescription'),
          redirectUrl: '',
          billingAddress: '',
          showCustomBtn: true,
          customButtonText: this.$t('message.result.processingButtonText'),
        };
      } else {
        this.warnModalInfo.modelValue = true;
      }
    },

    /**
     * 处理自定义按钮点击事件
     * @author Nemo
     * @date 2025-07-11
     */
    handleCustomButtonClick() {
      // 关闭弹窗
      this.resultPopup.visible = false;
    },

    /**
     * 检查是否应该继续轮询
     * @param {string} txnDate - 交易时间（北京时间）
     * @returns {boolean} - 是否应该继续轮询
     * @author Nemo
     * @date 2025-07-11
     */
    shouldContinuePolling(txnDate) {
      try {
        // 将北京时间转换为当前设备时区时间
        const localTxnTime = convertBeijingTimeToLocal(txnDate);
        if (!localTxnTime) {
          console.warn('时间转换失败，停止轮询', txnDate);
          return false;
        }

        // 解析交易时间
        const txnDateTime = new Date(localTxnTime);
        if (isNaN(txnDateTime.getTime())) {
          console.warn('无效的交易时间，停止轮询', localTxnTime);
          return false;
        }

        // 获取当前时间
        const currentTime = new Date();

        // 计算时间间隔（毫秒）
        const timeDifference = currentTime.getTime() - txnDateTime.getTime();

        // 15分钟 = 15 * 60 * 1000 毫秒
        const fifteenMinutes = 15 * 60 * 1000;

        // 检查条件：
        // 1. 当前时间晚于交易时间（timeDifference > 0）
        // 2. 时间间隔小于15分钟（timeDifference < fifteenMinutes）
        const shouldContinue = timeDifference > 0 && timeDifference < fifteenMinutes;

        if (!shouldContinue) {
          const intervalMinutes = Math.floor(timeDifference / 60000);
          console.log(`时间检查：交易时间 ${localTxnTime}, 当前时间 ${currentTime.toLocaleString()}, 间隔 ${intervalMinutes} 分钟`);
        }

        return shouldContinue;
      } catch (error) {
        console.error('时间检查异常：', error);
        return false;
      }
    },
  },
  computed: {
    isMobile: () => {
      // 通过设备判断
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    },
  },

};
</script>
<style lang="scss" scoped>
*{
  box-sizing: border-box;
  list-style: none;
  margin: 0;
  padding: 0;
}
.local-wrapper {
  height: 100vh;
  background-color: #fff;
}

.payment-container {
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  gap: 110px;
  justify-content: center;
}

.left-section {
  flex: 1;
  max-width: 366px;
  margin-top: 90px;
}

.right-section {
  flex: 1;
  padding-top: 90px;
  padding-left: 110px;
  background: #FFFFFF;
  position: relative;
  box-shadow: -10px 0px 20px 0px rgba(0, 0, 0, 0.102);

  height: 100%;
  .content{
    max-width: 406px;
    border-radius: 8px;
    border: 1px solid rgba(24, 32, 88, 0.1);
    padding: 24px;
    background: #FFFFFF;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    .validity-section{
      .scan-title {
        font-family: 'Open Sans-regular';
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0px;
        color: #1A202C;
        }
        .validity-badge {
          font-family: 'Open Sans-regular';
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: 0px;
          color: #182058;
        }
    }
  }
}

.payment-method {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px solid #C9CDD4;
  padding-bottom: 23px;
}

.payment-method-label {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #667085;
}

.payment-logo {
  height: 32px;
  width: auto;
}

.payment-logo-placeholder {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #3b82f6;
  padding: 8px 16px;
  background: rgba(59, 130, 246, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(59, 130, 246, 0.2);
}

.validity-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 16px 0;
}

.validity-icon {
  font-size: 14px;
}

.validity-text {
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #3b82f6;
}

.qr-section {
  text-align: center;
}

.warning-info{
  font-family: 'Open Sans-regular';
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  color: #F53F3F;
  margin:16px 0;
}
.qr-code-container {
  display: flex;
  justify-content: center;
  align-content: center;
}
.ticket-item {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    gap: 10px;

    .button {
      padding: 0;

      .icon-rongqi {
        font-size: 20px;
        color: var(--color-primary);
      }
    }
  }

.qr-code-image {
  width: 300px;
  height: 300px;
  object-fit: contain;
}
.download-btn {
  position: relative;
  width: 100%;
  height: 44px;
  border-radius: 8px;
  padding: 8px 24px;
  background: #182058;
  color: #fff;
  font-family: 'Open Sans-regular';
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon-down{
    position: absolute;
    top: 12px;
    right: 12px;
    width: 14px;
    height: 14px;
  }
  // &:hover {
  //   transform: translateY(-1px);
  //   box-shadow: 0 4px 12px rgba(59, 77, 102, 0.3);
  // }

  // &:active {
  //   transform: translateY(0);
  // }
}

.payment-status-check {
  margin-top: 24px;
  text-align: center;
  max-width: 406px;

  .status-text-1 {
    font-family: 'Open Sans regular';
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: center;
    color: #8D98AF;
    margin-bottom: 4px;
  }

  .status-text-2 {
    font-family: 'Open Sans regular';
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: center;
    text-decoration: underline;
    color: #182058;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}

.download-icon {
  font-size: 16px;
}

.error-msg {
  text-align: center;
  padding: 100px 20px;
  max-width: 600px;
  margin: 0 auto;

  .unknow {
    width: 120px;
    height: auto;
    margin-bottom: 24px;
  }

  .tips {
    font-family: 'Open Sans', sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: #667085;
    line-height: 24px;
  }
}

// 移动端响应式
@media screen and (max-width: 768px) {
  .local-wrapper {
    background-color: #F9FAFB;
    padding: 16px;
    overflow-x: hidden;
  }
  .payment-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
  }

  .left-section,
  .right-section {
    background: #fff;
    max-width: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    flex: 0;

  }
  .left-section{
    // padding: 16px 16px 0;
    .product-content{
      padding: 0;
    }
    .order-summary{
      padding: 0;
    }
  }
  .right-section {
    box-shadow: none;
    .content{
      padding: 16px;
    }

    .payment-status-check {
      padding: 16px 16px;
      margin: 0;
      background: #F9FAFB !important;
      position: relative;
    }
  }
  .payment-method {
    margin-bottom: 20px;
  }

  .payment-method-label {
    font-size: 13px;
  }

  .payment-logo {
    height: 28px;
  }

  .payment-logo-placeholder {
    font-size: 14px;
    padding: 6px 12px;
  }

  .validity-section {
    margin-bottom: 24px;
  }

  .validity-text {
    font-size: 13px;
  }

  .scan-title {
    font-size: 18px;
    // margin-bottom: 14px;
  }

  .warning-info {
    line-height: 18px;
    font-size: 13px;
    margin-bottom: 8px;
  }

  .qr-code-image {
    width: 220px;
    height: 220px;
  }

  .download-btn {
    padding: 14px 28px;
    font-size: 15px;
    min-width: 140px;
  }

      .payment-status-check {
    margin-top: 20px;

    .status-text-1,
    .status-text-2 {
      font-size: 11px;
      line-height: 14px;
    }
  }
}
</style>
<style lang="scss">
.left-section{
  .order-summary{
    padding: 0;
    .product-content{
      padding: 0;
    }
  }
}
.local-wrapper{
  .el-button--text{
    color: #182058;
  }
}

</style>
